<div class="mbm-loading" role="status"
  [attr.aria-label]="messageKey() === null ? ('general.loading' | translate) : null">
  <img class="mbm-loading-spinner" src="assets/icons/spinner-loading.svg" alt="" aria-hidden="true" />
  @if (messageKey() !== null) {
    <p class="mbm-loading-message">{{ messageKey()! | translate }}</p>
  }
</div>
